import { useCallback, useMemo } from "react";
import { Menu, Dropdown } from "antd";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { ROUTES } from "utils/constants";

import { actionMenu } from "svgs";
import {BatteryModelState, BatteryState} from "types/store";
import {setModalName, setSelectedBatteryModel} from "../../../store/actions";


export default function DropdownAction({
  model,
}: {
  model: BatteryModelState["selectedBatteryModel"];
}) {
  const dispatch = useDispatch();


    const onDelete = useCallback(() => {
        dispatch(setSelectedBatteryModel(model));
        dispatch(setModalName("delete_battery_model"));
    }, [dispatch]);


  const menu = useMemo(
    () => (
      <Menu>
        <Menu.Item key="1">
        </Menu.Item>
        <Menu.Item key="3" className="delete-action" onClick={onDelete}>
          Archive
        </Menu.Item>

      </Menu>
    ),
    [onDelete]
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <a className="ant-dropdown-link">{actionMenu}</a>
    </Dropdown>
  );
}
